export default __webpack_public_path__ + "media/1554bbf94644614e1cd7ec97b119daed24e761e4fc60a973f44639132703142a.svg";